import React, { useState } from "react";
import { primaryTextColor, fw400, titleL } from "../../../../Global.module.css";
import styles from "./PictureRight.module.css";
import TitleBlock from "../../LayoutBlocks/TitleBlock/TitleBlock";
import TextBlock from "../../LayoutBlocks/TextBlock/TextBlock";
import ImageBlock from "../../LayoutBlocks/ImageBlock/ImageBlock";
import MediaUploader from "../../MediaUploader/MediaUploader";
import Modal from "../../../reusable/Modal/Modal";
import embedOptions from "../../EmbedOptions.json";
import VideoBlock from "../../LayoutBlocks/VideoBlock/VideoBlock";
import ImageCrop from "../../ImageCrop/ImageCrop";

export default function PictureRight({ id, data, onChange }) {
	const [showUploader, setUploader] = useState(false);
	const [cropImage, setCropImage] = useState("");

	const onTitleChange = (value) => {
		onChange({
			...data,
			title: value,
		});
	};

	const onContentChange = (value) => {
		onChange({
			...data,
			content: value,
		});
	};

	const onMediaSelect = (mediaType, src) => {
		if (mediaType === embedOptions.Image) {
			setCropImage(src);
		} else if (mediaType === embedOptions.Video) {
			onChange({
				...data,
				mediaType: mediaType,
				src: src,
			});
		}
	};

	const onMediaDelete = () => {
		onChange({
			...data,
			mediaType: "",
			src: "",
		});
	};

	const updateImage = (image) => {
		setCropImage(false);
		if (image) {
			onChange({
				...data,
				mediaType: embedOptions.Image,
				src: image,
			});
		} else {
			onChange({
				...data,
				mediaType: "",
				src: "",
			});
		}
	};
	const alignTitle = (alignment) => {
		onChange({
			...data,
			alignTitle: alignment,
		});
	};

	const alignContent = (alignment) => {
		onChange({
			...data,
			alignContent: alignment,
		});
	};

	const handleUploadMedia = () => {
		setUploader(!showUploader);
	};

	const getBlock = (mediaType) => {
		switch (mediaType) {
			case embedOptions.Image:
				return <ImageBlock src={data.src} onDelete={onMediaDelete} />;
			case embedOptions.Video:
				return <VideoBlock src={data.src} onDelete={onMediaDelete} />;

			default:
				return <></>;
		}
	};

	return (
		<div id={id} className={styles.pictureRight}>
			<TitleBlock
				title={data.title}
				onChange={onTitleChange}
				alignment={data.alignTitle}
				changeAlignment={alignTitle}
			/>
			<div className={styles.doubleContent}>
				<TextBlock
					content={data.content}
					onChange={onContentChange}
					alignment={data.alignContent}
					changeAlignment={alignContent}
				/>
				{data.src ? (
					getBlock(data.mediaType)
				) : (
					<div className={styles.actions}>
						<button
							className={`${styles.btn} ${primaryTextColor} ${fw400} ${titleL}`}
							onClick={handleUploadMedia}
						>
							Add Media
						</button>
					</div>
				)}
			</div>
			{cropImage ? (
				<ImageCrop src={cropImage} onComplete={updateImage} />
			) : null}
			{showUploader ? (
				<Modal>
					<MediaUploader
						mediaSelected={onMediaSelect}
						closeUploader={handleUploadMedia}
						fullSize={false}
					/>
				</Modal>
			) : null}
		</div>
	);
}
